/*
 * @Description:
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-08-04 17:41:15
 * @LastEditTime: 2020-08-07 11:26:04
 */
import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/alarmSet/alarmAreaAlarmSet/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 批量删除报警设置
 * @param {*} data
 */
export function FetchDeleteCommonAlarmSetBatch(data) {
  return request({
    url: "/alarmSet/commonAlarmSet/deleteCommonAlarmSetBatch",
    method: "post",
    data
  });
}

/**
 * 初始化车辆树
 */
// export function FetchFindVehicleTree() {
//   return request({
//     url: "/tms/vehicleInfo/getOrgVehicleTree",
//     method: "post"
//   });
// }

/**
 * 初始化区域树
 */
export function FetchFindAreaTree() {
  return request({
    url: "/alarmSet/alarmAreaAlarmSet/getCorpAreaTree",
    method: "post"
  });
}

/**
 * 保存报警设置
 */
export function FetchSaveAreaAlarmSet(data) {
  return request({
    url: "/alarmSet/alarmAreaAlarmSet/saveAlarmAreaAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 根据ID获取报警设置
 */
export function FetchFindAreaAlarmById(data) {
  return request({
    url: "/alarmSet/alarmAreaAlarmSet/getAlarmAreaAlarmSetById",
    method: "post",
    data
  });
}

/**
 * 批量删除报警设置
 * @param {*} data
 */
export function FetchDeleteAreaAlarmSetBatch(data) {
  return request({
    url: "/alarmSet/commonAlarmSet/deleteCommonAlarmSetBatch",
    method: "post",
    data
  });
}
